<div class="cancellation-container p-5 mt-3">
    <h5>{{ policies?.title }}</h5>
    <p>{{ policies?.short_desc }}</p>
    <button type="button" class="btn btn-outline-secondary rounded">Learn More</button>
</div>